module.exports = __webpack_public_path__ + "static/media/BI.b649c388.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BI.svg
// module id = 205
// module chunks = 0